"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainSaga = void 0;
const serviceConfigs_1 = require("@configs/serviceConfigs");
const modalUtils_1 = require("@containers/common/utils/modalUtils");
const common_1 = __importDefault(require("@service/common"));
const effects_1 = require("redux-saga/effects");
const dataProcessing_1 = require("../service/dataProcessing");
const index_1 = require("./index");
function* fetchSearchUsers(action) {
    try {
        yield (0, effects_1.put)((0, index_1.SET_LOADING_STATE)(true));
        const convertedRequest = (0, dataProcessing_1.getParametersOfSearchAPI)(action.payload);
        const response = yield (0, effects_1.call)(common_1.default.searchUsers, convertedRequest);
        const convertedResponse = (0, dataProcessing_1.convertResponseOfSearchAPI)(response);
        yield (0, effects_1.put)((0, index_1.SET_SEARCH_RESULT)(convertedResponse));
        yield (0, effects_1.put)((0, index_1.SET_API_STATUS)({ type: 'search', code: serviceConfigs_1.HTTP_STATUS_CODE.OK }));
    }
    catch (error) {
        console.error(error);
        yield (0, effects_1.put)((0, index_1.SET_API_STATUS)({ type: 'search', code: error.code }));
        // yield put(
        //     SET_IS_STATUS_MODAL_OPEN({
        //         statusModalType: StatusModalTypes.FAIL,
        //         isOpen: true,
        //         message: error.errorMessage || '查詢失敗'
        //     })
        // );
    }
    finally {
        yield (0, effects_1.put)((0, index_1.SET_LOADING_STATE)(false));
    }
}
function* fetchAddUser(action) {
    try {
        yield (0, effects_1.put)((0, index_1.SET_LOADING_STATE)(true));
        yield (0, effects_1.put)((0, modalUtils_1.openStatusModal)('FAIL', '功能尚未開放' || action));
    }
    catch (error) {
        console.error(error);
        yield (0, effects_1.put)((0, index_1.SET_API_STATUS)({ type: 'search', code: error.code }));
    }
    finally {
        yield (0, effects_1.put)((0, index_1.SET_LOADING_STATE)(false));
    }
}
function* MainSaga() {
    yield (0, effects_1.takeEvery)(index_1.FETCH_SEARCH, fetchSearchUsers);
    yield (0, effects_1.takeEvery)(index_1.FETCH_ADD, fetchAddUser);
}
exports.MainSaga = MainSaga;
